module.exports = __webpack_public_path__ + "icon-gemfire.3-TNXYas.svg";